export const getCheckoutItemsRejectedAction = (state, action) => {
	if (!action.meta.aborted) {
		state.items = [];
		state.savedForLaterItems = [];
		state.success = false;
		state.isLoading = false;
		state.errorMessage = 'There was an error while fetching the vehicles.';
	}
};
